module.exports = __webpack_public_path__ + "img/photot_student.51324ea9.png";